import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import * as atualizacaoOrcamentoLegadoActions from 'app/redux/atualizacaoOrcamentoLegadoSlice'
import { sobrescreverInformacoesAction } from "app/redux/orcamentoSlice"

declare var window: any

export async function aplicarDescontoCashback(aplicar: boolean) {
    const orcamentoAtualizado = await microuniversoApi.Orcamento.AplicarDescontoCashback(
        store.getState().orcamento.IdentificadorOrcamento,
        aplicar
    )

    const atualizarEstado = () => {
        const orcamentoLegado = window.orcamentoController.model
        orcamentoLegado.atualizar(orcamentoAtualizado, true, true)
        store.dispatch(sobrescreverInformacoesAction(orcamentoAtualizado))
        store.dispatch(atualizacaoOrcamentoLegadoActions.atualizar(orcamentoAtualizado))
    }

    atualizarEstado()
}